// The value of each entry is the path variable so casing is important
export enum DoesUserHavePermissionEntityType {
  LOCATION = 'location',
  PRODUCT = 'product',
}
